module.exports = __webpack_public_path__ + "img/date3-icon.976d23a1.png";